import * as React from 'react';
import { Paragraph2 } from '@cian/ui-kit';

import { SalesStartTooltip } from '../SalesStartTooltip';
import * as styles from './SalesStartInfo.css';

interface ISalesStartInfo {
  content: string;
}

export function SalesStartInfo({ content }: ISalesStartInfo) {
  return (
    <Paragraph2>
      {content}
      <span className={styles['tooltip']}>
        <SalesStartTooltip />
      </span>
    </Paragraph2>
  );
}
